import React, { useState } from "react";
import { logo } from "../Assets";

const menuItems = [
  { id: 1, label: "HOME",link:"/" },
  { id: 7, label: "WHITELIST CHECKER" },


];
const NavbarChecker = ({ chosenRef, worldRef, factionRef, mintRef, roadmapRef, whitelistRef }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (ref) => {
    console.log("ref", ref)
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <nav className="w-full relative z-20 -mt-16 lg:-mt-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-12 lg:px-8 py-4 ">
          <div className="flex items-center justify-between h-16 ">
            {/* Logo - top-left with chamfered feel */}
            <a href="/" className="text-2xl text-white pr-4 pt-2" >
              <img src={logo} alt="Logo" className="w-60" />
            </a>

            {/* Desktop Menu */}
            <div className="hidden lg:flex items-center space-x-8">
              {menuItems.map((item) => (
                <a
                  key={item.id}
                  href={item.link}
                  target="_blank"
                  id={item.elementId}
                  rel="noopener noreferrer"
                  className="text-white hover:text-gray-300 transition cursor-pointer "

                  onClick={
                    item.id === 2 ? () => scrollToSection(worldRef) :
                      item.id === 3 ? () => scrollToSection(chosenRef) :
                        item.id === 4 ? () => scrollToSection(factionRef) :
                          item.id === 5 ? () => scrollToSection(mintRef) :
                            item.id === 6 ? () => scrollToSection(roadmapRef)
                              : item.id === 7
                                ? () => scrollToSection(whitelistRef) : null

                  }
                >
                  {item.label}
                </a>
              ))}
              <button
                className="bg-[#06FF3C]/50 -mt-10  text-black px-6 py-2 text-sm rounded-tr-3xl rounded-bl-3xl hover:opacity-80 transition shadow-[0_0_10px_#06FF3C] disabled:cursor-not-allowed "
                disabled
              >
                CONNECT WALLET
              </button>
            </div>

            {/* Mobile Menu */}
            <div className="lg:hidden flex items-center">
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="text-white focus:outline-none"
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d={
                      isMenuOpen
                        ? "M6 18L18 6M6 6l12 12"
                        : "M4 6h16M4 12h16M4 18h16"
                    }
                  />
                </svg>
              </button>
            </div>
          </div>

          {/* Mobile Dropdown Menu */}
          {isMenuOpen && (
            <div className="lg:hidden bg-black text-white flex flex-col items-center space-y-4 py-4">
              {menuItems.map((item) => (
                <a
                  key={item.id}
                  // href={item.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-gray-300 transition"
                  onClick={
                    item.id === 2 ? () => scrollToSection(worldRef) :
                      item.id === 3 ? () => scrollToSection(chosenRef) :
                        item.id === 4 ? () => scrollToSection(factionRef) :
                          item.id === 5 ? () => scrollToSection(mintRef) :
                            item.id === 6 ? () => scrollToSection(roadmapRef) :
                              item.id === 7
                                ? () => scrollToSection(whitelistRef) :
                                null

                  }
                >
                  {item.label}
                </a>
              ))}
              <button
                className="bg-[#06FF3C]/5 opacity-15 -mt-10  text-black px-6 py-2 text-sm rounded-tr-3xl rounded-bl-3xl hover:opacity-80 transition shadow-[0_0_10px_#06FF3C]"
              >
                CONNECT WALLET
              </button>
            </div>
          )}
        </div>
      </nav>
    </>
  );
};

export default NavbarChecker;